import { Box, Link } from '@material-ui/core';
import React from 'react';
import { useSelection } from "../hooks/use-selection.js";
export const ShowSelectedButton = _ref => {
  let {
    localization,
    className,
    handleClick
  } = _ref;
  const {
    selection
  } = useSelection();
  return /*#__PURE__*/React.createElement(Box, {
    className: className,
    "data-test": "show-selected-container"
  }, /*#__PURE__*/React.createElement(Link, {
    component: "button",
    variant: "body2",
    onClick: handleClick
  }, localization.label, " (", selection.length, ")"));
};
//# sourceMappingURL=show-selected-button.js.map